// 
export const colors = {
  primary: "#2563EB",
  primaryDark: "#1D4ED8",

  sidebar: "#0F172A",
  sidebarHover: "#1E293B",
  sidebarActive: "#2563EB",

  background: "#F8FAFC",
  card: "#FFFFFF",

  border: "#E2E8F0",

  text: "#0F172A",
  textSecondary: "#64748B",

  danger: "#DC2626",
  success: "#16A34A"
};